<template>
  <v-container class="pa-0">
    <v-row :class="$vuetify.breakpoint.mdAndUp ? 'flex-nowrap' : ''">
      <v-col cols="12" sm="7" lg="8">
        <v-card class="half-radius px-10 py-9" min-height="400">
          <v-row>
            <v-col cols="12" sm="6" v-for="(item, index) in answers" :key="index" class="px-5 py-2">
              <v-card flat>
                <v-img
                  :src="questions[index].question_file"
                  class="half-radius"
                  :aspect-ratio="16 / 9"
                  contain
                >
                  <v-avatar
                    size="27"
                    color="#168EEA"
                    class="ml-2 mt-2 white--text body-2 custom-avatar"
                    >{{ index + 1 }}</v-avatar
                  >
                </v-img>
                <v-text-field
                  v-model="answers[index].content"
                  dense
                  class="body-2 mt-2"
                  placeholder="Answer"
                  :readonly="index === 0 || finished"
                  :class="{ 'font-italic': index === 0 }"
                />
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-6 text-center">
              <v-btn
                v-if="!finished"
                small
                depressed
                width="100"
                :disabled="finished"
                :loading="loading"
                class="white--text text-capitalize"
                color="#29284c"
                @click="onFinish"
                >Finish</v-btn
              >
              <ProgressResetButton
                v-else
                :stepType="stepType"
                :stepUuid="stepUuid"
                @reset="
                  onReset();
                  extraCreate();
                "
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <app-answer-key :finished="finished" :questions="questions" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import AnswerKey from "./../AnswerKey.vue";
import studentMixin from "@/mixins/studentMixin";
import answerMixin from "@/mixins/answerMixin";
import ProgressResetButton from "@/components/Utils/ProgressResetButton.vue";

export default {
  components: {
    appAnswerKey: AnswerKey,
    ProgressResetButton,
  },
  props: {
    stepUuid: {
      type: String,
      required: true,
    },
    questions: {
      required: true,
      type: Array,
    },
  },
  mixins: [studentMixin, answerMixin],
  methods: {
    wrongAnswer(index) {
      if (typeof this.answers[index].content !== "string") {
        return false;
      }
      return (
        this.answers[index].content.toLowerCase() !==
        this.questions[index].good_answer.toLowerCase()
      );
    },
    errorMessages(index) {
      const errors = [];
      this.finished && index !== 0 && this.wrongAnswer(index) && errors.push("Wrong Answer");
      return errors;
    },
    successMessages(index) {
      const success = [];
      this.finished && index !== 0 && !this.wrongAnswer(index) && success.push("Correct Answer");
      return success;
    },
    extraCreate() {
      this.answers[0].content = this.questions[0].good_answer;
    },
  },
};
</script>
<style scoped>
.custom-avatar {
  border: 1px #c5eeff solid !important;
}
</style>
